import { Component, Input, OnInit } from '@angular/core';
import { LayerId } from '../../../../types';
import { TimelineStore } from '../../timeline.store';

@Component({
  selector: 'app-timeline-layer-select',
  templateUrl: './timeline-layer-select.component.html',
  styleUrls: ['./timeline-layer-select.component.styl']
})
export class TimelineLayerSelectComponent implements OnInit {
  @Input() layerId: LayerId;

  constructor(private timelineStore: TimelineStore) {
  }

  ngOnInit() {
  }

  get selected(): boolean {
    return this.timelineStore.selectedLayerId === this.layerId;
  }

  onClick() {
    this.timelineStore.selectedLayerId = this.layerId;
  }
}



// WEBPACK FOOTER //
// ./src/app/rec/timeline/timeline-layer/timeline-layer-select/timeline-layer-select.component.ts